export default {
      id: "ic_check_circle-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_check_circle-usage",
      toString: function () {
        return this.url;
      }
    }